const OilChangeType = {
  dieselMonoGrade: "diesel-monograde",
  dieselMultiGrade: "diesel-multigrade",
  dieselFullySynthetic: "diesel-fully-synthetic",
  gasolineMonoGrade: "gasoline-monograde",
  gasolineMultiGrade: "gasoline-multigrade",
  gasolineFullySynthetic: "gasoline-fully-synthetic",
  gasolineFullySynthetic5W40: "gasoline-fully-synthetic-5w-40",
};

export default OilChangeType;
